<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ORIM-Dedication">This faithful but unpretending record<br/>of a remarkable adventure<br/>is hereby respectfully dedicated<br/>by the narrator,<br/><br/>ALLAN QUATERMAIN,<br/><br/>to all the big and little boys<br/>who read it.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled11.vue?8e6e794a